import {
  AppBar,
  Button,
  ButtonGroup,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Slide,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import { Tag } from 'antd';
import React, { memo, useContext, useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useSnackbar } from 'notistack';
import { uploadFileApi } from "../../../../api's/BIApi";
import { AWS_CONFIG_TYPE, AZURE_BLOB_STORAGE, S3_BUCKET_NAME } from '../../../../BaseUrl';
import { WorkflowContext } from '../../../../contexts/WorkflowProvider';
import InputField from '../../../../reusable-component/InputField';
import generateAlias from '../../../../utils/generateAlias';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const NodeModalFileUploader = ({ open, handleClose, nodeId, nodeName, nodes, edges, changeNodeName, setNodes }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { workflow } = useContext(WorkflowContext);
  const workflowName = workflow?.workflow_name;
  const clientName = workflow?.engagement.client.client_name;
  const engagementName = workflow?.engagement.engagement_name;
  const inputPath = `${clientName}/${engagementName}/${workflowName}/x360-inputs`;
  const initial_path = AWS_CONFIG_TYPE
    ? `s3://${S3_BUCKET_NAME}/${inputPath}`
    : `https://${AZURE_BLOB_STORAGE}.blob.core.windows.net/dep-develop/${inputPath}`;

  const INITIALSTATE = {
    alias: generateAlias(nodeName, nodeId),
    path: initial_path,
    sample_view: true,
  };
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [formField, setFormField] = useState(INITIALSTATE);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [isDataLoad, setisDataLoad] = useState(false);
  const [tempHeader, setTempHeader] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    if (store) {
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setisDataLoad(true);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    value = e.target.value;

    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleFormsubmit = (e) => {
    e.preventDefault();
    if (AWS_CONFIG_TYPE === true) {
      enqueueSnackbar('Upload Functionality is not implemented in AWS !!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      return;
    }

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleResetForm = () => {
    setDisableForm(false);
    setFormField(INITIALSTATE);
    setFileUploaded(false);
    setSelectedFile(null);
    setFetchedHeader([]);
    setHeaderName([]);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
  };

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUploadFile = async () => {
    setLoading(true);
    if (selectedFile) {
      try {
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('file_name', selectedFile.name);
        formData.append('file_path', inputPath);
        formData.append('cloud_environment', workflow.cloudEnvironment);

        const response = await uploadFileApi(formData);
        if (response.status === 200) {
          setLoading(false);
          setFileUploaded(true);
          enqueueSnackbar('File uploaded successfully!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      } catch (error) {
        setLoading(false);
        setFileUploaded(false);
        enqueueSnackbar('Error while uploading the file!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    } else {
      setLoading(false);
      enqueueSnackbar('Please select a file!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const handleCopyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      enqueueSnackbar('Path copied to clipboard!', {
        variant: 'success',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      enqueueSnackbar('Failed to copy!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  return (
    <div>
      <Dialog fullScreen open={open} TransitionComponent={Transition} style={{ width: '70%', marginLeft: '30%' }}>
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={!disableForm}
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: '20px' }}>
            <input type="hidden" value={nodeId} />
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <FormControl sx={{ minWidth: 270, marginBottom: '16px' }}>
                  <InputField name="alias" label="Alias" value={formField.alias} size="small" disabled required />
                </FormControl>
              </Grid>
            </Grid>

            <Typography variant="h6" gutterBottom>
              Upload your file
            </Typography>
            <TextField
              type="file"
              inputProps={{ accept: '*' }}
              onChange={handleFileSelect}
              disabled={disableForm}
              variant="outlined"
              fullWidth
              sx={{ marginBottom: '20px' }}
            />
            <Button
              variant="contained"
              color="primary"
              startIcon={<UploadFileIcon />}
              onClick={handleUploadFile}
              disabled={!selectedFile || disableForm}
              sx={{
                marginBottom: '50px',
              }}
              fullWidth
            >
              Upload File
            </Button>
            {loading && (
              <>
                <LinearProgress />
                <br />
              </>
            )}

            {fileUploaded && (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{
                      width: '100%',
                      marginBottom: '16px',
                    }}
                  >
                    <TextField
                      id="filepath"
                      name="path"
                      label="Output Path"
                      value={`${formField.path}/${selectedFile.name}`}
                      size="small"
                      disabled
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleCopyToClipboard(`${formField.path}/${selectedFile.name}`)}
                              edge="end"
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                  <Tag color="#f50" size="medium">
                    Remember to save the output path before it disappears.
                  </Tag>
                </Grid>
              </Grid>
            )}
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default memo(NodeModalFileUploader);
